import { DateTimeEditor, DropdownEditor, TextEditor } from '@approvalmax/ui';
import { PlainDataProvider } from 'modules/data-providers';
import { memo, useCallback } from 'react';

import { SectionContainer } from '../../../../../components/SectionContainer';
import { messages } from './JournalEntryHeaderFields.messages';
import { FieldsWrapper, StyledField } from './JournalEntryHeaderFields.styles';
import { JournalEntryHeaderFieldsProps } from './JournalEntryHeaderFields.types';

const JournalEntryHeaderFields = memo<JournalEntryHeaderFieldsProps>((props) => {
    const { fieldValues, currencies, showCurrencyField, showErrors, onFieldChange, onCurrencyChange } = props;

    const onNumberChange = useCallback(
        (newValue: string | null) => {
            onFieldChange('journalNumber', newValue);
        },
        [onFieldChange]
    );

    const onDateChange = useCallback(
        (newValue: string | null) => {
            onFieldChange('journalDate', newValue);
        },
        [onFieldChange]
    );

    return (
        <div>
            <SectionContainer title={null}>
                <FieldsWrapper>
                    {showCurrencyField && (
                        <StyledField title={messages.currency} required>
                            <PlainDataProvider items={currencies}>
                                <DropdownEditor
                                    value={fieldValues.currency || null}
                                    singleLinePerItem={false}
                                    onChange={onCurrencyChange}
                                    placeholder={messages.currencyPlaceholder}
                                    invalid={showErrors && !fieldValues.currency}
                                    loading={false}
                                />
                            </PlainDataProvider>
                        </StyledField>
                    )}

                    <StyledField title={messages.journalDate} required>
                        <DateTimeEditor
                            value={fieldValues.journalDate || null}
                            placeholder={messages.journalDatePlaceholder}
                            invalid={showErrors && !fieldValues.journalDate}
                            onChange={onDateChange}
                        />
                    </StyledField>

                    <StyledField title={messages.journalNumber} required>
                        <TextEditor
                            value={fieldValues.journalNumber || ''}
                            onChange={onNumberChange}
                            placeholder={messages.journalNumberPlaceholder}
                            invalid={showErrors && !fieldValues.journalNumber}
                            changeOnBlur
                            maxLength={21}
                        />
                    </StyledField>
                </FieldsWrapper>
            </SectionContainer>
        </div>
    );
});

export default JournalEntryHeaderFields;
